module.exports = __webpack_public_path__ + "static/media/test13_4.2f3b4b02.png";